// extracted by mini-css-extract-plugin
export default {"container":"OnBoardingPageG_container__TKSZI","containerText":"OnBoardingPageG_containerText__qnr6k","animation":"OnBoardingPageG_animation__fqs0b"};